// extracted by mini-css-extract-plugin
module.exports = {"tags":"_1mOndL","tagContainer":"_3nh-mU","tag":"_1EQ8ZI","tagIcon":"_1YqqJj","shine-lines":"_2to7c-"};